export function SunIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path
        fill={color}
        d="M6.05 4.14l-.39-.39a.993.993 0 00-1.4 0l-.01.01a.984.984 0 000 1.4l.39.39c.39.39 1.01.39 1.4 0l.01-.01a.984.984 0 000-1.4zM3.01 10.5H1.99c-.55 0-.99.44-.99.99v.01c0 .55.44.99.99.99H3c.56.01 1-.43 1-.98v-.01c0-.56-.44-1-.99-1zm9-9.95H12c-.56 0-1 .44-1 .99v.96c0 .55.44.99.99.99H12c.56.01 1-.43 1-.98v-.97c0-.55-.44-.99-.99-.99zm7.74 3.21c-.39-.39-1.02-.39-1.41-.01l-.39.39a.984.984 0 000 1.4l.01.01c.39.39 1.02.39 1.4 0l.39-.39a.984.984 0 000-1.4zm-1.81 15.1l.39.39a.996.996 0 101.41-1.41l-.39-.39a.993.993 0 00-1.4 0c-.4.4-.4 1.02-.01 1.41zM20 11.49v.01c0 .55.44.99.99.99H22c.55 0 .99-.44.99-.99v-.01c0-.55-.44-.99-.99-.99h-1.01c-.55 0-.99.44-.99.99zM12 5.5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-.01 16.95H12c.55 0 .99-.44.99-.99v-.96c0-.55-.44-.99-.99-.99h-.01c-.55 0-.99.44-.99.99v.96c0 .55.44.99.99.99zm-7.74-3.21c.39.39 1.02.39 1.41 0l.39-.39a.993.993 0 000-1.4l-.01-.01a.996.996 0 00-1.41 0l-.39.39c-.38.4-.38 1.02.01 1.41z"
      />
    </svg>
  );
}
